<template>
	<div>
		<div v-if="!visualizar">
			<div class="no-print">
				<div v-if="!modal && cabecalho" class="fl-cabecalho no-print">
					<div class="row">
						<div class="col-xs-12 col-md-3">
							<i class="icon icon-desapacho_aeronaves"></i>
							<h3>{{ _traducao('global', 'programacao').toUpperCase() }}</h3>
							<h4>{{ _traducao('global', 'voo').toUpperCase() }}</h4>
						</div>
						<div class="col-md-5 col-xs-12">
							<span v-if="form.id == 0">
								<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
								<h3>{{ _traducao('global', 'nova') }}</h3>
							</span>

							<span v-if="form.id != 0">
								<i class="icon icon-editar icon-sub"></i>
								<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
							</span>

							<h4>{{ _traducao('global', 'programacao').toUpperCase() }}</h4>
						</div>

						<div class="col-md-4 col-xs-12" v-if="!programacaoDiario">
							<button
								@click="voltaLista()"
								:title="_traducao('global', 'voltar')"
								class="btn btn-default pull-right btn-lg"
							>
								<i
									class="icon-left"
									style="font-size: 18px"
									aria-hidden="true"
								></i>
							</button>

							<!-- <button
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'imprimir')"
								v-show="form.id != 0"
								style="margin-right: 20px"
								type="button"
								@click="clickPrint(300)"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</button> -->
						</div>
					</div>
				</div>

				<div class="row" style="margin-bottom: 15px">
					<div class="col-xs-12" s>
						<ul class="nav nav-tabs">
							<li
								role="presentation"
								class="text-center"
								:class="[
									{active: filtro == 'identificacao'},
									{'erro-tab': erro.tabIdentificacao}
								]"
							>
								<a href="#" @click.prevent="filtro = 'identificacao'">
									<i class="icon-novo_cadastro" style="font-size: 20px"></i
									><br />
									{{ _traducao('global', 'identificacaoVoo') }}
								</a>
							</li>
							<li
								role="presentation"
								class="text-center"
								:class="[
									{active: filtro == 'aeronave'},
									{'erro-tab': erro.tabAeronave}
								]"
							>
								<a href="#" @click.prevent="filtro = 'aeronave'">
									<i class="icon-solicitacao" style="font-size: 20px"></i><br />
									{{ _traducao('global', 'aeronave') }}
								</a>
							</li>
							<li
								role="presentation"
								class="text-center"
								:class="[
									{active: filtro == 'trecho'},
									{'erro-tab': erro.tabTrecho}
								]"
								v-if="!form.id_malha_voo"
							>
								<a href="#" @click.prevent="filtro = 'trecho'">
									<i
										class="icon icon-desapacho_aeronaves"
										style="font-size: 20px"
									></i
									><br />
									{{ _traducao('global', 'trecho') }}
								</a>
							</li>
							<li
								role="presentation"
								class="text-center"
								:class="[
									{active: filtro == 'passageiro'},
									{'erro-tab': erro.tabPassageiro}
								]"
								v-if="!form.id_malha_voo"
							>
								<a href="#" @click.prevent="filtro = 'passageiro'">
									<i
										class="icon icon-cadastro_usuarios"
										style="font-size: 20px"
									></i
									><br />
									<span v-if="tripulacaoTecnica == '1'">{{
										_traducao('global', 'tripulacaoTecnica')
									}}</span>
									<span v-else>{{ _traducao('global', 'passageiro') }}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div v-show="filtro === 'identificacao'">
					<identificacaoVoo
						ref="identificacaoVoo"
						:form="form"
						:erro="erro"
						:subclassificacoes="subclassificacoes"
						:classificacoes="classificacoes"
						:tipos-missao="tipos_missao"
						:orgaos-apoiados="orgaosApoiados"
						:ativar-classificacao="ativarClassificacao"
					/>
				</div>
				<div v-show="filtro === 'aeronave'">
					<aeronave
						ref="aeronave"
						:form="form"
						:erro="erro"
						:aeronaves="aeronaves"
						:bases="bases"
						:funcoes="listaDeFuncoes"
					/>
				</div>

				<div v-show="filtro === 'trecho'">
					<trechoProgramacao
						ref="trechoProgramacao"
						:form="form"
						:aeronaves="aeronaves"
					/>
				</div>

				<div v-show="filtro === 'passageiro'">
					<flPassageiro
						ref="flPassageiro"
						:form="form.aeronave"
						:disabled="false"
						:exibir-estimado="true"
						@validar-cpf-passageiro="
							(indexFormPassageiro, formPassageiro) =>
								validarCPFPassageiro(indexFormPassageiro, formPassageiro, 0)
						"
					/>
				</div>

				<!-- BTN SALVAR -->
				<div>
					<div class="row" style="margin-bottom: 20px">
						<hr
							style="margin-top: 2px; margin-bottom: 20px; margin-top: 20px"
						/>
						<div class="col-lg-10 col-xs-9"></div>
						<div class="col-lg-2 col-xs-12">
							<p
								style="color: rgb(233, 44, 44)"
								v-show="existeTripulantesDuplicados"
							>
								Existem tripulantes duplicados, favor conferir!
							</p>
							<button
								type="button"
								:disabled="desabilitarSalvar || existeTripulantesDuplicados"
								@click.prevent="clickSalva"
								class="btn btn-block btn-success pull-right"
							>
								<i class="fa fa-check" aria-hidden="true"></i>
								{{ _traducao('global', 'salvar').toUpperCase() }}
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="print">
				<flPrint ref="printCadastro" />
			</div>
		</div>

		<div v-if="visualizar">
			<!-- cabecalho -->

			<div class="fl-cabecalho no-print" v-if="cabecalho">
				<div class="row">
					<div class="col-md-4 col-xs-12">
						<i class="icon icon-desapacho_aeronaves"></i>
						<h3>{{ _traducao('global', 'programacao').toUpperCase() }}</h3>
						<h4>{{ _traducao('global', 'voo').toUpperCase() }}</h4>
					</div>

					<div class="col-md-4 col-xs-12">
						<i class="icon icon-vizualizar icon-sub"></i>
						<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
						<h4>{{ _traducao('global', 'voo').toUpperCase() }}</h4>
					</div>

					<div class="col-md-4 col-xs-12">
						<button
							@click="voltaLista()"
							class="btn btn-default pull-right btn-lg"
							:title="_traducao('global', 'voltar')"
						>
							<i
								class="icon-left"
								style="font-size: 18px"
								aria-hidden="true"
							></i>
						</button>

						<button
							class="btn btn-default pull-right btn-lg"
							:title="_traducao('global', 'imprimir')"
							style="margin-right: 20px"
							@click="_print()"
						>
							<i class="icon-imprimir" style="font-size: 18px"></i>
						</button>
					</div>
				</div>
			</div>

			<flPrint ref="printVisualizar" />
		</div>
		<copiar ref="copiar" @copiar-voo="(item) => preencherVoo(item)" />

		<!-- MODAL SOLICITACAO OK -->
		<modal ref="modalOk">
			<button type="button" class="close" @click="$refs.modalOk.modalHide()">
				<span aria-hidden="true">&times;</span>
			</button>
			<h4 class="modal-title">
				{{ _traducao('global', 'despacho').toUpperCase() }}
			</h4>

			<hr />

			<h2 class="text-center text-success">
				<i class="fa fa-check-circle"></i>
				{{ _traducao('global', 'despachoSalvo').toUpperCase() }}
			</h2>

			<h2 class="text-center">
				{{ _traducao('global', 'numero').toUpperCase() }}: <br /><strong>{{
					form.numero
				}}</strong>
			</h2>

			<button
				class="btn btn-default"
				type="button"
				@click="
					$refs.modalOk.modalHide()
					voltaLista()
				"
			>
				<i class="icon-left"></i>
				{{ _traducao('menuAGcadAluno', 'voltarParaLista') }}
			</button>

			<!-- <button
				class="btn btn-default pull-right"
				type="button"
				@click="
					$refs.modalOk.modalHide()
					clickPrint(300)
				"
			>
				<i class="icon-imprimir"></i> {{ _traducao('global', 'imprimir') }}
			</button> -->
		</modal>
	</div>
</template>

<script>
import flPrint from './print.vue'
import trechoFactory from '@/factories/solicitacao/editando'
import passageiroMixin from '@/modules/components/passageiro/mixin'
import trechoMixin from '@//modules/components/trecho/mixin'
import identificacaoVoo from './components/identificacaoVoo.vue'
import aeronave from './components/aeronave.vue'
import trechoProgramacao from './components/trecho.vue'
import copiar from './components/copiarTemplate.vue'

export default {
	mixins: [passageiroMixin, trechoMixin],
	components: {
		flPrint,
		identificacaoVoo,
		aeronave,
		trechoProgramacao,
		copiar
	},

	props: {
		visualizar: {
			required: true,
			type: Boolean
		},

		cabecalho: {
			type: Boolean,
			required: false,
			default: true
		},

		aeronaves: {
			type: Array,
			default: () => []
		},

		subclassificacoes: {
			type: Array,
			default: () => []
		},

		classificacoes: {
			type: Array,
			default: () => []
		},

		bases: {
			type: Array,
			default: () => []
		},

		rotaER: {
			type: Array,
			default: () => []
		},

		orgaosApoiados: {
			type: Array,
			default: () => []
		},
		programacaoDiario: {
			type: Boolean,
			default: false
		},
		ativarClassificacao: {
			type: Boolean,
			default: false
		},
		tripulacaoTecnica: {
			type: String,
			default: '0'
		},
		tripulacaoNaoObrigatoria: {
			type: Boolean,
			default: false
		},
		disabledDatahora: {
			type: Boolean,
			default: false
		},
		vooConcomitantesAtivo: {
			type: Boolean,
			default: false
		},
		fixarTextoCampoHistorico: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		editando() {
			return this.form.id == 0 ? false : true
		},
		existeTripulantesDuplicados() {
			const possuiNomesDuplicados = this.form.aeronave.tripulacao.some(
				(tripulante, index) => {
					const nomeAtual = tripulante.usuarios
					return this.form.aeronave.tripulacao
						.slice(0, index)
						.some(
							(trip) =>
								trip.usuarios === nomeAtual &&
								trip.alteracao != 'excluir_usuario'
						)
				}
			)
			return possuiNomesDuplicados
		}
	},

	data() {
		return {
			filtro: 'identificacao',
			desabilitarSalvar: false,
			listaDeFuncoes: [],
			modal: false,
			ver: false,
			id_aeronave: null,
			form: {
				editar: false,
				id: 0,
				id_ordem_missao: null,
				identificacao_voo: null,
				subclassificacao: '',
				classificacao: '',
				id_tipo_missao: 0,
				id_orgao: 0,
				aeronave: {
					id_aeronave: 0,
					novo: true,
					alteracao_aeronave: null,
					tripulacao: [],
					base: '0',
					voo_instrucao: '0',
					trecho: [trechoFactory.createTrecho(false, this.disabledDatahora)],
					roteiro: [],
					passageiro: [],
					passageiros: 0,
					existe_passageiro: false,
					quantidade_estimada_passageiros: 0,
					erro_passageiros: null,
					roteiro: [],
					distanciaTotal: 0,
					combustivelTotal: 0,
					tempoTotal: 0
				},
				fechado: false,
				nome_usuario_inseriu: '',
				data_cadastro: '',
				ordem_data_inicio: '',
				ordem_codigo: '',
				ordem_descricao: '',
				id_ordem_missao: '',
				tipo: 'E',
				_tipo: '',
				id_usuario: '',
				numero: '',
				status: '',
				data_inicio: '',
				numero_bo: '',
				numero_chamada: '',
				ocorrencia193Obrigatoria: '',
				numero_atividade: '',

				houve_contexto: '0',
				contexto_operativo: '',
				historico: 'N/A',
				relatorio_voo_trecho: [],
				orgao_apoiado: [],
				orgao: {},
				descricao_malha_voo: null,
				id_malha_voo: null,
				numero_voo: null,
				icao_origem: null,
				icao_destino: null,
				decolagem_prevista: null,
				pouso_previsto: null,
				orgao: '0'
			},
			erro: {
				tabIdentificacao: false,
				tabAeronave: null,
				tabTrecho: null,
				tabPassageiro: null,

				identificacao_voo: null,
				subclassificacao: null,
				classificacao: null,
				id_tipo_missao: null,
				id_orgao: null,

				aeronave: {
					id_aeronave: null,
					base: null
				},
				tipo: '',
				data_inicio: '',
				numero_bo: '',
				ocorrencia193Obrigatoria: '',
				numero_chamada: '',

				houve_contexto: '',
				contexto_operativo: '',
				historico: '',
				orgao_apoiado: ''
			},
			utilizaTrigrama: true,
			tipos_missao: [],
			passageirosExcluidos: [],
			flagComponente: $cliente.get('componente_trecho_solicitacao')
		}
	},

	created() {
		this.carregaTiposMissao()
		this.carregaFuncoesBordo()
		this.form.id_usuario = $sessao.getId()
		this.utilizaTrigrama = $cliente.get('utiliza_trigrama') === '1'
	},

	methods: {
		carregaFuncoesBordo() {
			this._axios('/Funcao_bordo/listar', 'get', {
				callback: ({lista}) => {
					this.listaDeFuncoes = lista.map((item) => {
						item.descricao = item.descricao.toLowerCase()
						return item
					})
				}
			})
		},

		novo() {
			this.carregaHistorico()
			this.fechado = false
			this.$refs.copiar.carregaVooMalha()
		},

		async editar(item) {
			this.form.editar = true
			this.tripulantes = await this.getTripulantes()
			this.listaDeFuncoes = this.listaDeFuncoes.map((funcao) => {
				funcao.tripulantes = this.tripulantes.filter(
					(tripulante) => tripulante.id_funcao_bordo === funcao.id
				) || [];
				return funcao
			})
			this.carrega(item)
		},

		async getTripulantes() {
			return new Promise((resolve) => {
				window.bus.$emit('load-in', {
					text: this._traducao('global', 'carregando')
				})
				this._axios('Usuario/get_tripulantes', 'get', {
					callback(response) {
						if (response._request && response._status) {
							resolve(response.lista)
						}
					},
					finally: () => {
						window.bus.$emit('load-out')
					}
				})
			})
		},

		async carregaDespachos() {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			this._httpGet('mg-siga/Despacho_emergencial/copiar', (retorno) => {
				if (retorno._request && retorno._status) {
					if (retorno.lista.length > 0) {
						this.form.id = 0
						this.carregaDadosAeronave(retorno.lista)

						this.form.identificacao_voo = retorno.lista.numero_voo
						this.form._tipo = retorno.lista._tipo
						this.form.nome_usuario_inseriu = retorno.lista.nome_usuario_inseriu
						this.form.data_cadastro = retorno.lista.data_cadastro
						this.form.historico = retorno.lista.historico
						this.form.tipo = retorno.lista.tipo
						this.form.id_tipo_missao = retorno.lista.tipo_missao.id
						this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
							return o.id == retorno.lista.id_subclassificacao
						})
					} else {
						window.bus.$emit('load-out')
						bus.$emit('exibir-notificacao', {
							text: this._traducao('global', 'naoExisteDespachoAvulso'),
							type: 'danger'
						})
					}
				}
			})
		},

		voltaLista() {
			this.$emit('volta-lista')
		},

		async clickSalva() {
			bus.$emit('load-in', {text: this._traducao('global', 'salvando')})
			if (await this.validaForm()) {
				if (
					Object.keys(this.form.orgao).length == 0 ||
					this.form.orgao == '0'
				) {
					this.form.orgao = 0
				} else {
					if (!Array.isArray(this.form.orgao)) {
						this.form.orgao = [this.form.orgao]
					}
				}
				const latAndLongDecimalArray = this.form.aeronave.trecho.map(
					(trecho) => ({
						latOrigem: this._convertDD(trecho.lat_partida, 'lat'),
						lngOrigem: this._convertDD(trecho.lng_partida, 'lng'),
						latDestino: this._convertDD(trecho.lat_destino, 'lat'),
						lngDestino: this._convertDD(trecho.lng_destino, 'lng')
					})
				)

				var data = {
					id: this.form.id,
					aeronave: this.form.aeronave,
					id_usuario: $sessao.getId(),
					id_subclassificacao: this.form.subclassificacao
						? this.form.subclassificacao.id
						: '',
					id_classificacao: this.form.classificacao
						? this.form.classificacao.id
						: '',
					houve_contexto: this.form.houve_contexto,
					historico: this.form.historico,
					id_ordem_missao: this.form.id_ordem_missao,
					tipo: this.form.tipo,
					id_tipo_missao: this.form.id_tipo_missao,
					orgao: this.form.orgao,
					identificacao: this.form.identificacao_voo,
					id_malha_voo: this.form.id_malha_voo,
					data_inicio: this._dateTimeToDateSQL(
						this.form.data_inicio,
						$sessao.getDateFormat() + ' HH:MM'
					),
					trechoDecimal: latAndLongDecimalArray
				}

				this._httpPost(
					'mg-siga/Despacho_emergencial/salvar_despacho_comercial',
					data,
					(response) => {
						if (response._request && response._status) {
							this.form.numero = response.lista.numero
							this.form.id = response.lista.id

							if (this.form.orgao != 0) {
								this.form.orgao = {
									descricao: this.form.orgao[0].descricao,
									excluido: this.form.orgao[0].excluido,
									id: this.form.orgao[0].id,
									id_orgao: this.form.orgao[0].id_orgao,
									nivel: this.form.orgao[0].nivel,
									sigla: this.form.orgao[0].sigla,
									unidade: []
								}
							}

							if (!this.modal && !this.programacaoDiario) {
								this.$refs.modalOk.modalShow(60)
							}

							this.$emit('despacho-add', response.lista)
						}
					}
				)
			} else {
				bus.$emit('exibir-notificacao', {
					text: this._traducao('menuEscala', 'menuEvermelho'),
					type: 'danger'
				})
			}
			bus.$emit('load-out')
		},

		async validaForm() {
			var passou = true
			var trechoConflito = this._traducao('global', 'trechoConflito')
			var obrigatorio = this._traducao('global', 'campoObrigatorio')

			if (this.form.identificacao_voo === null) {
				this.erro.identificacao_voo = obrigatorio
				passou = false
				this.erro.tabIdentificacao = true
				this.filtro = this.filtro == 'identicacao' ? null : this.filtro
			} else {
				this.erro.identificacao_voo = null
			}
			if (!_.isObject(this.form.orgao)) {
				this.erro.id_orgao = obrigatorio
				passou = false
				this.erro.tabIdentificacao = true
				this.filtro = this.filtro == 'identicacao' ? null : this.filtro
			} else {
				this.erro.id_orgao = null
			}
			if (this.form.id_tipo_missao == 0 && !this.ativarClassificacao) {
				this.erro.id_tipo_missao = obrigatorio
				passou = false
				this.erro.tabIdentificacao = true
				this.filtro = this.filtro == 'identicacao' ? null : this.filtro
			} else {
				this.erro.id_tipo_missao = null
			}
			if (this.ativarClassificacao) {
				if (this.form.classificacao === '') {
					this.erro.classificacao = obrigatorio
					passou = false
				} else {
					this.erro.classificacao = null
				}
				if (this.form.subclassificacao === '') {
					this.erro.subclassificacao = obrigatorio
					passou = false
					this.erro.tabIdentificacao = true
					this.filtro = this.filtro == 'identicacao' ? null : this.filtro
				} else {
					this.erro.subclassificacao = null
				}

				if (
					!this.erro.identificacao_voo &&
					!this.erro.subclassificacao &&
					!this.erro.id_tipo_missao
				) {
					this.erro.tabIdentificacao = false
				}
			} else {
				if (!this.erro.identificacao_voo && !this.erro.id_tipo_missao) {
					this.erro.tabIdentificacao = false
				}
			}

			if (this.form.aeronave.id_aeronave === 0) {
				this.erro.aeronave.id_aeronave = obrigatorio
				passou = false
				this.erro.tabAeronave = true
			} else {
				this.erro.aeronave.id_aeronave = null
				var erroTrip = 0

				if (!this.tripulacaoNaoObrigatoria) {
					const countTripulacao = this.form.aeronave.tripulacao.length

					for (let t = 0; t < countTripulacao; t++) {
						if (this.form.aeronave.tripulacao[t].funcao === 0) {
							this.form.aeronave.tripulacao[t].erroFuncao = obrigatorio
							passou = false
							this.erro.tabAeronave = true
							erroTrip++
						} else {
							this.form.aeronave.tripulacao[t].erroFuncao = null
						}
						if (this.form.aeronave.tripulacao[t].usuarios.length === 0) {
							this.form.aeronave.tripulacao[t].erroNome = obrigatorio
							passou = false
							this.erro.tabAeronave = true
							erroTrip++
						} else {
							this.form.aeronave.tripulacao[t].erroNome = null
						}
					}
				}
			}
			if (this.form.aeronave.base == 0) {
				this.erro.aeronave.base = obrigatorio
				passou = false
				this.erro.tabAeronave = true
			} else {
				this.erro.aeronave.base = null
			}

			if (
				!this.erro.aeronave.id_aeronave &&
				erroTrip === 0 &&
				!this.erro.aeronave.base
			) {
				this.erro.tabAeronave = false
			}

			if (!this.form.id_malha_voo) {
				var erroTrecho = 0
				let partidaAnterior = null
				let pousoAnterior = null
				for (const trecho of this.form.aeronave.trecho) {
					const pousoAtual = moment(
						`${trecho.pouso_previsto} ${trecho.pouso_previsto_hora}`,
						'DD/MM/YYYY HH:mm'
					)
					const partidaAtual = moment(
						`${trecho.decolagem_partida} ${trecho.decolagem_partida_hora}`,
						'DD/MM/YYYY HH:mm'
					)
					const sqlPartida = this._dateTimeToDateSQL(
						partidaAtual._i,
						'DD/MM/YYYY HH:MM:SS'
					)
					const sqlPouso = this._dateTimeToDateSQL(
						pousoAtual._i,
						'DD/MM/YYYY HH:MM:SS'
					)
					let retorno = ''
					const {
						pouso_previsto,
						pouso_previsto_hora,
						decolagem_partida,
						decolagem_partida_hora
					} = trecho
					if (
						sqlPartida &&
						sqlPouso &&
						pouso_previsto &&
						pouso_previsto_hora &&
						decolagem_partida &&
						decolagem_partida_hora &&
						!this.vooConcomitantesAtivo
					) {
						retorno = await this.AsyncChecaTrechoConflitante(
							this.form.aeronave.id_aeronave,
							sqlPartida,
							sqlPouso,
							this.form.id
						)
					}
					if (trecho.estado_partida.length === 0) {
						trecho.erro_estado_partida = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_estado_partida = ''
					}
					if (trecho.cidade_partida === '') {
						trecho.erro_cidade_partida = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_cidade_partida = ''
					}
					if (trecho.designativo_partida === '') {
						trecho.erro_designativo_partida = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_designativo_partida = ''
					}
					if (trecho.lat_partida === '') {
						trecho.erro_lat_partida = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_lat_partida = ''
					}
					if (trecho.lng_partida === '') {
						trecho.erro_lng_partida = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_lng_partida = ''
					}
					if (
						trecho.decolagem_partida === '' ||
						trecho.decolagem_partida === null ||
						trecho.decolagem_partida_hora === '' ||
						trecho.decolagem_partida_hora === null
					) {
						trecho.erro_decolagem = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_decolagem = ''
					}
					if (trecho.estado_destino.length === 0) {
						trecho.erro_estado_destino = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_estado_destino = ''
					}
					if (trecho.cidade_destino === '') {
						trecho.erro_cidade_destino = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_cidade_destino = ''
					}
					if (!trecho.nao_tem_aerodromo) {
						if (trecho.designativo_destino === '') {
							trecho.erro_designativo_destino = obrigatorio
							passou = false
							this.erro.tabTrecho = true
							erroTrecho++
						} else {
							trecho.erro_designativo_destino = ''
						}
						if (trecho.lat_destino === '') {
							trecho.erro_lat_destino = obrigatorio
							passou = false
							this.erro.tabTrecho = true
							erroTrecho++
						} else {
							trecho.erro_lat_destino = ''
						}
						if (trecho.lng_destino === '') {
							trecho.erro_lng_destino = obrigatorio
							passou = false
							this.erro.tabTrecho = true
							erroTrecho++
						} else {
							trecho.erro_lng_destino = ''
						}
					} else {
						if (trecho.descricao_destino === '') {
							trecho.erro_descricao_destino = obrigatorio
							passou = false
							this.erro.tabTrecho = true
							erroTrecho++
						} else {
							trecho.erro_descricao_destino = ''
						}
						if (trecho.lat_destino === '') {
							trecho.erro_lat_destino = obrigatorio
							passou = false
							this.erro.tabTrecho = true
							erroTrecho++
						} else {
							trecho.erro_lat_destino = ''
						}
						if (trecho.lng_destino === '') {
							trecho.erro_lng_destino = obrigatorio
							passou = false
							this.erro.tabTrecho = true
							erroTrecho++
						} else {
							trecho.erro_lng_destino = ''
						}
					}

					if (
						trecho.pouso_previsto === '' ||
						trecho.pouso_previsto === null ||
						trecho.pouso_previsto_hora === ''
					) {
						trecho.erro_pouso_previsto = obrigatorio
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					} else {
						trecho.erro_pouso_previsto = ''					
						if (partidaAnterior) {
							if (
								partidaAtual.isBetween(partidaAnterior, pousoAnterior) ||
								partidaAtual.isBefore(partidaAnterior)
							) {
								trecho.erro_decolagem =
									'Horário do trecho conflitante com trecho anterior.'
								trecho.erro_pouso_previsto =
									'Horário do trecho conflitante com trecho anterior.'
								passou = false
								this.erro.tabTrecho = true
								erroTrecho++
							}
						} else {
							partidaAnterior = partidaAtual
							pousoAnterior = pousoAtual
							trecho.erro_pouso_previsto = ''
							trecho.erro_decolagem = ''
						}
					}
					if (retorno.trecho_conflito) {
						trecho.erro_decolagem = trechoConflito
						trecho.erro_pouso_previsto = trechoConflito
						passou = false
						this.erro.tabTrecho = true
						erroTrecho++
					}
				}

				if (erroTrecho === 0) {
					this.erro.tabTrecho = false
				}

				var erroPassageiro = 0
				if (this.form.aeronave.existe_passageiro) {
					if (
						this.form.aeronave.passageiros === 0 &&
						this.form.aeronave.quantidade_estimada_passageiros == 0
					) {
						this.form.aeronave.erro_passageiros =
							'Nenhuma quantidade de passageiro confirmados/estimado preenchido'
						passou = false
						this.erro.tabPassageiro = true
						erroPassageiro++
					} else {
						this.form.aeronave.erro_passageiros = ''
						if (this.form.aeronave.passageiors >= 1) {
							this.form.aeronave.erro_passageiros = ''
							const countPassageiro = this.form.aeronave.passageiro.length
							for (let p = 0; p < countPassageiro; p++) {
								if (this.form.aeronave.passageiro[p].nome === '') {
									this.form.aeronave.passageiro[p].nomeErro = obrigatorio
									passou = false
									this.erro.tabPassageiro = true
									erroPassageiro++
								} else {
									this.form.aeronave.passageiro[p].nomeErro = null
								}
								if (this.form.aeronave.passageiro[p].peso === 0) {
									this.form.aeronave.passageiro[p].pesoPassageiroErro =
										obrigatorio
									passou = false
									this.erro.tabPassageiro = true
									erroPassageiro++
								} else {
									this.form.aeronave.passageiro[p].pesoPassageiroErro = null
								}
							}

							// if (this.form.aeronave.passageiro[p].trecho[0].designativo_partida === '' || this.form.aeronave.passageiro[p].trecho[0].designativo_destino === ''){
							// 	this.form.aeronave.passageiro[p].trechoErro = obrigatorio
							// 	passou = false
							// 	this.erro.tabPassageiro = true;
							// 	this.erro.tabTrecho = true;
							// 	erroPassageiro ++;
							// } else {
							// 	this.form.aeronave.passageiro[p].trechoErro = null
							// }
						}
					}
				}

				if (erroPassageiro === 0) {
					this.erro.tabPassageiro = false
				}
			}

			return passou
		},
		carregaHistorico() {
			this._axios('/mg-siga/Despacho_emergencial/get_ultimo_historico', 'get', {
				callback: (response) => {
					if (response._status && response._request) {
						this.form.historico = this.fixarTextoCampoHistorico
							? response.historico.historico
							: ''
					}
				}
			})
		},
		AsyncChecaTrechoConflitante(id_aeronave, inicio, fim, id = null) {
			return new Promise((resolve) => {
				this._axios(
					`mg-siga/Despacho_emergencial/verifica_trecho_programacao/${id_aeronave}/${inicio}/${fim}/${id}`,
					'get',
					{
						callback: (response) => {
							resolve(response)
						}
					}
				)
			})
		},

		async carrega(item) {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			this._httpGet(
				'mg-siga/Despacho_emergencial/get_despacho_comercial/' + item.id,
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.form.id = retorno.lista.id
						this.form.data_inicio = this._SQLDateToDateTime(
							retorno.lista.data_inicio,
							$sessao.getDateFormat() + ' HH:MM'
						)
						this.carregaDadosAeronave(retorno.lista)

						this.form.orgao = retorno.lista.orgao
						this.form.identificacao_voo = retorno.lista.numero_voo
						this.form.numero_bo = retorno.lista.reds
						this.form.numero_chamada = retorno.lista.chamada
						this.form._tipo = retorno.lista._tipo
						this.form.nome_usuario_inseriu = retorno.lista.nome_usuario_inseriu
						this.form.data_cadastro = retorno.lista.data_cadastro
						this.form.numero_atividade = retorno.lista.atividade
						this.form.houve_contexto = retorno.lista.houve_contexto
						this.form.historico = retorno.lista.historico
						this.form.numero = retorno.lista.numero
						if (!_.isNil(retorno.lista.relatorio_voo_trecho)) {
							this.form.relatorio_voo_trecho =
								retorno.lista.relatorio_voo_trecho
						} else {
							this.form.relatorio_voo_trecho = []
						}

						this.form.status = retorno.lista.status
						this.form.id_ordem_missao = retorno.lista.id_ordem_missao
						this.form.tipo = retorno.lista.tipo
						this.form.ordem_descricao = retorno.lista.ordem_descricao
						this.form.ordem_codigo = retorno.lista.ordem_codigo
						this.form.ordem_data_inicio = retorno.lista.ordem_data_inicio
						this.form.classificacao = _.find(this.classificacoes, (o) => {
							return o.id == retorno.lista.id_classificacao
						})
						this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
							return o.id == retorno.lista.id_subclassificacao
						})

						if (!retorno.lista.id_orgao_apoiado) {
							this.form.orgao = '0'
						} else {
							this.form.orgao = _.find(this.orgaosApoiados, (o) => {
								return o.id == retorno.lista.id_orgao_apoiado
							})
						}

						this.form.id_tipo_missao =
							retorno.lista.tipo_missao != null
								? retorno.lista.tipo_missao.id
								: '0'
						if (this.visualizar) {
							this.$refs.printVisualizar.carregaDados(this.form)
						}
						this.form.id_malha_voo = retorno.lista.id_malha_voo
						this.form.descricao_malha_voo = retorno.lista.descricao_malha_voo
						this.form.numero_voo = retorno.lista.numero_voo
						this.form.icao_destino = retorno.lista.icao_destino
						this.form.icao_origem = retorno.lista.icao_origem
						this.form.decolagem_prevista = retorno.lista.decolagem_prevista
						this.form.pouso_previsto = retorno.lista.pouso_previsto
						this.form.id_ordem_missao = retorno.lista.id_ordem_missao
					}
				}
			)
			window.bus.$emit('load-out')
		},

		validarCPFPassageiro(indexFormPassageiro, formPassageiro, indexAeronave) {
			const oldFormPassageiro =
				this.form.aeronave[0].passageiro[indexFormPassageiro]

			if (formPassageiro.cpf) {
				this._httpGet(
					'/Usuario/validador_de_cpf/' + formPassageiro.cpf,
					(retorno) => {
						if (!retorno._status) {
							this.form.aeronave[0].passageiro.splice(indexFormPassageiro, 1, {
								...oldFormPassageiro,
								cpfErro: this._traducao('global', 'cpfInvalido')
							})
						} else {
							this.form.aeronave[0].passageiro.splice(indexFormPassageiro, 1, {
								...oldFormPassageiro,
								cpfErro: ''
							})
						}
					}
				)
			} else {
				this.form.aeronave[0].passageiro.splice(indexFormPassageiro, 1, {
					...oldFormPassageiro,
					cpfErro: ''
				})
			}
		},

		getSubclassificacaoById(id) {
			for (var i in this.subclassificacoes) {
				if (this.subclassificacoes[i].id == id) {
					return this.subclassificacoes[i]
				}
			}
		},

		carregaBase(descricao) {
			for (var i = 0; i < this.bases.length; i++) {
				if (descricao == this.bases[i].descricao) {
					this.form.aeronave[0].base = this.bases[i].id
				}
			}
		},

		clickPrint(tempo) {
			setTimeout(() => {
				this.$refs.printCadastro.carregaDados(this.form)
				this.$nextTick(() => {
					this._print()
				})
			}, tempo)
		},

		carregaTiposMissao() {
			this._httpGet('/Tipo_missao/get', (retorno) => {
				if (retorno._request && retorno._status) {
					this.tipos_missao = retorno.lista
				}
			})
		},

		adicionaPosicao(funcao, nome) {
			const func = this.getTripulantesByFuncao(funcao, this.listaDeFuncoes)
			if (Array.isArray(func)) {
				return []
			}
			return func.filter((t) => t.nome === nome)
		},

		getTripulantesByFuncao(funcao, funcoes) {
			const found = funcoes.find((i) => i.descricao === funcao)
			if (found) {
				return found.tripulantes
			}
			return []
		},
		carregaPesoM(item) {
			switch (item.sexo) {
				case 'c':
					item.pesoMedio = 30
					break
				case 'f':
					item.pesoMedio = 70
					break
				case 'm':
					item.pesoMedio = 80
					break
				default:
					item.pesoMedio = 0
			}
		},
		async carregaDadosAeronave(dados) {
			this.form.aeronave.id_aeronave = dados.aeronave.id_aeronave
			this.form.aeronave.base = dados.aeronave.base
			this.form.aeronave.novo = false
			this.form.aeronave.alteracao_aeronave = dados.aeronave.alteracao_aeronave
			this.form.aeronave.id = dados.aeronave.id
			const countTrip = dados.aeronave.tripulacao.length
			for (let i = 0; i < countTrip; i++) {
				this.form.aeronave.tripulacao.push({
					id: dados.aeronave.tripulacao[i].id,
					funcao: dados.aeronave.tripulacao[i].funcao,
					erroNome: null,
					erroFuncao: null,
					load: false,
					usuarios: dados.aeronave.tripulacao[i],
					novo: false,
					alteracao: dados.aeronave.tripulacao[i].tipo_alteracao,
					usuarios2: this.adicionaPosicao(
						dados.aeronave.tripulacao[i].funcao,
						dados.aeronave.tripulacao[i].nome
					),
					dadosTripulanteOld: dados.aeronave.tripulacao[i].id_usuario
				})
			}
			this.form.aeronave.trecho = await this.carregarEditarTrecho(
				dados.aeronave.trecho,
				false
			)
			if (
				dados.aeronave.passageiro.length > 0 ||
				dados.aeronave.quantidade_estimada_passageiros > 0
			) {
				this.form.aeronave.existe_passageiro = true
				this.form.aeronave.passageiros = dados.aeronave.passageiro.length
				this.form.aeronave.passageiro = dados.aeronave.passageiro.map(
					(item) => {
						this.carregaPesoM(item)
						return item
					}
				)
				this.form.aeronave.quantidade_estimada_passageiros =
					dados.aeronave.quantidade_estimada_passageiros
			}

			if (!dados.id_malha_voo) {
				this.form.aeronave.passageiros = dados.aeronave.passageiro.length
				this.form.aeronave.passageiro = dados.aeronave.passageiro.map(
					(passageiro) => {
						passageiro.peso =
							passageiro.peso < 0
								? this.toNumberCasa(passageiro.peso, 2) * -1
								: this.toNumberCasa(passageiro.peso, 2)
						passageiro.peso_bagagem_mao =
							passageiro.peso_bagagem_mao < 0
								? this.toNumberCasa(passageiro.peso_bagagem_mao, 2) * -1
								: this.toNumberCasa(passageiro.peso_bagagem_mao, 2)
						passageiro.peso_bagagem_porao =
							passageiro.peso_bagagem_porao < 0
								? this.toNumberCasa(passageiro.peso_bagagem_porao, 2) * -1
								: this.toNumberCasa(passageiro.peso_bagagem_porao, 2)
						passageiro.passagem =
							passageiro.passagem < 0
								? this.toNumberCasa(passageiro.passagem, 2) * -1
								: this.toNumberCasa(passageiro.passagem, 2)
						passageiro.nomeErro = ''
						passageiro.orgaoErro = ''
						passageiro.cargoErro = ''
						passageiro.cpfErro = ''
						passageiro.trechoErro = ''
						passageiro.telefoneErro = ''
						passageiro.trecho = this.geraTrechoPessoa(
							passageiro,
							this.form.aeronave.trecho
						)
						return passageiro
					}
				)
			}
			this.form.aeronave.roteiro = dados.aeronave.roteiro.map((item, index) => {
				item.decolagem_data = this._SQLDateToDateTime(
					item.decolagem,
					$sessao.getDateFormat() + ' HH:MM'
				).split(' ')[0]
				item.decolagem_hora = this._SQLDateToDateTime(
					item.decolagem,
					$sessao.getDateFormat() + ' HH:MM'
				).split(' ')[1]
				item.img = ''
				item.clima = ''
				item.temperatura = ''
				item.combustivel = item.combustivel
				item.tempo = item.tempo
				return item
			})

			if (this.visualizar) {
				this.clickAtualizarRoteiro(null, this.form.aeronave.roteiro)
			}

			this.$nextTick(() => {
				if (!this.visualizar) {
					this.$refs.trechoProgramacao.clickAtualizarRoteiro()
				}
			})
		},

		convertDecimal(tempo) {
			var valorDecimal = null
			if (tempo) {
				const [horas, minutos, segundos] = tempo.split(':').map(Number)

				const minutosFracao = minutos / 60
				const segundosFracao = segundos / 3600

				const valorDecimal = horas + minutosFracao + segundosFracao
			}

			return valorDecimal
		},

		clickAtualizarRoteiro(roteiro, rot) {
			var aero = _.find(this.aeronaves, (aeronave) => {
				return aeronave.id == this.form.aeronave.id_aeronave
			})
			if (aero) {
				this.form.aeronave.roteiro = []
				this.form.aeronave.distanciaTotal = 0
				this.form.aeronave.combustivelTotal = 0
				this.form.aeronave.tempoTotal = ''
				this.form.aeronave.trecho.map((item, i) => {
					var roteiro = this.criaRoteiro(item, i, aero, rot)
					this.form.aeronave.roteiro.push(roteiro)
					if(Array.isArray(rot) && rot.length > 0){
						this.form.aeronave.roteiro[i].combustivel = rot[i].combustivel
					}
				})
			}
		},

		atualizaPousoPrevisto(trecho, aero) {
			var distancia = this.calculoDistancia(
				trecho.lat_partida,
				trecho.lng_partida,
				trecho.lat_destino,
				trecho.lng_destino
			)

			let tempo = null
			switch (this.flagComponente) {
				case 'basico':
					trecho = this.geratempoPousoPrevisto(distancia, aero, trecho)
					break
				case 'avancado':
					if (
						trecho.decolagem_partida != null &&
						trecho.decolagem_partida != '' &&
						trecho.decolagem_partida_hora != null &&
						trecho.decolagem_partida_hora != ''
					) {
						const dataDecolagem = new Date(
							trecho.decolagem_partida + ' ' + trecho.decolagem_partida_hora
						)
						if (trecho.pouso_previsto != null && trecho.pouso_previsto != '') {
							const dataPouso = new Date(
								trecho.pouso_previsto + ' ' + trecho.pouso_previsto_hora
							)
							trecho.pouso = trecho.pouso_previsto_hora
							const diferencaEmMilissegundos = dataPouso - dataDecolagem

							const diferencaEmHoras = Math.floor(
								diferencaEmMilissegundos / (1000 * 60 * 60)
							)
							const diferencaEmMinutos = Math.floor(
								(diferencaEmMilissegundos % (1000 * 60 * 60)) / (1000 * 60)
							)
							const diferencaEmSegundos = Math.floor(
								(diferencaEmMilissegundos % (1000 * 60)) / 1000
							)

							trecho.tempo = `${diferencaEmHoras
								.toString()
								.padStart(2, '0')}:${diferencaEmMinutos
								.toString()
								.padStart(2, '0')}:${String(diferencaEmSegundos).padStart(
								2,
								'0'
							)}`
						} else {
							trecho = this.geratempoPousoPrevisto(distancia, aero, trecho)
						}

						break
					}
			}

			return trecho
		},

		geratempoPousoPrevisto(distancia, aeronave, trecho) {
			let tempo = null
			if (distancia) {
				tempo = Number(distancia) / Number(aeronave.velocidade)
				tempo = this._calculaTempo(tempo)
				const [horas, minutos, segundos] = tempo.split(':').map(Number)
				const totalSegundosAAdicionar = horas * 3600 + minutos * 60 + segundos

				const acionamentoDataHora =
					trecho.decolagem_partida + ' ' + trecho.decolagem_partida_hora
				const formatoDataHora = 'DD/MM/YYYY HH:mm'
				const dataHoraInicial = moment(acionamentoDataHora, formatoDataHora)

				const novaDataHora = dataHoraInicial.add(
					totalSegundosAAdicionar,
					'seconds'
				)

				const novaDataHoraFormatada = novaDataHora.format(formatoDataHora)
				const horarioPouso = novaDataHoraFormatada.split(' ')
				trecho.pouso_previsto = horarioPouso[0]
				trecho.pouso_previsto_hora = horarioPouso[1]

				trecho.tempo = tempo
				trecho.pouso = this._calculaPouso(trecho.decolagem_partida_hora, tempo)
			}
			return trecho
		},

		decimalToTime(decimal) {
			if (!decimal) {
				return '00:00'
			}
			const [horas, minutos] = parseFloat(decimal).toFixed(2).split('.')
			return `${horas.padStart(2, 0)}:${(60 * (minutos / 100))
				.toFixed(0)
				.padStart(2, 0)}`
		},

		criaRoteiro(trecho, indexTrecho, aero, roteiro = null) {
			var self = this

			var item = {}
			item = {
				//partida
				cidade_partida: trecho.nome_cidade_partida,
				designativo_partida: trecho.designativo_partida.sigla,
				descricao_partida: trecho.descricao_partida,
				decolagem_data: trecho.decolagem_partida,
				decolagem_hora: trecho.decolagem_partida_hora,
				nascer_partida: null,
				por_partida: null,

				proa: 0,
				distancia: 0,
				tempo: trecho.tempo_utc ? trecho.tempo_utc : trecho.tempo_voo,
				combustivel: roteiro.combustivel,

				// destino
				cidade_destino: trecho.nome_cidade_destino,
				designativo_destino: trecho.designativo_destino.sigla,
				descricao_destino: trecho.descricao_destino,
				pouso_data: trecho.pouso_previsto,
				pouso_hora: trecho.pouso_previsto_hora,
				nascer_destino: null,
				por_destino: null,

				autonomia: 0
			}

			if (indexTrecho == 0) {
				if (aero.consumo == 0) {
					item.autonomia = 0
				} else {
					item.autonomia = this.decimalToTime(aero.tanque / aero.consumo)
				}
			}

			if (item.cidade_partida != '' && item.estado_partida != '') {
				self._getPrevisaoTempo(
					function (retorno) {
						if (retorno != false) {
							item.por_partida = retorno.porDoSol
							item.nascer_partida = retorno.nascerDoSol
						}
						self.$forceUpdate()
					},
					item.cidade_partida,
					item.estado_partida,
					0
				)
			}

			if (item.cidade_destino != '' && item.estado_destino != '') {
				self._getPrevisaoTempo(
					function (retorno) {
						if (retorno != false) {
							item.por_destino = retorno.porDoSol
							item.nascer_destino = retorno.nascerDoSol
						}
						self.$forceUpdate()
					},
					item.cidade_destino,
					item.estado_destino,
					0
				)
			}

			item.distancia = this.calculoDistancia(
				trecho.lat_partida,
				trecho.lng_partida,
				trecho.lat_destino,
				trecho.lng_destino
			)

			var lat1 = this._convertDD(trecho.lat_partida, 'lat')
			var lon1 = this._convertDD(trecho.lng_partida, 'lng')
			var lat2 = this._convertDD(trecho.lat_destino, 'lat')
			var lon2 = this._convertDD(trecho.lng_destino, 'lng')

			item.proa = 'N/A'

			if (
				item.designativo_partida &&
				item.designativo_partida == item.designativo_destino
			) {
				item.proa = 'N/A'
			} else {
				this._calculaProa(
					function (proa) {
						item.proa = Math.round(proa) + '°'
						self.$forceUpdate()
					},
					lat2,
					lon2,
					lat1,
					lon1
				)
			}

			this.form.aeronave.distanciaTotal = Number(
				Number(item.distancia) + Number(this.form.aeronave.distanciaTotal)
			).toFixed(1)
			if (aero.velocidade == null) {
				item.tempo = 'N/A'
				item.pouso = 'N/A'
				item.combustivel = 'N/A'
				this.form.aeronave.combustivelTotal = 'N/A'
			} else {
				if (trecho.tempo_voo) {
					let tempoDeVoo = trecho.tempo_utc
						? trecho.tempo_utc
						: trecho.tempo_voo
					item.tempo = tempoDeVoo
					item.combustivel = Number((aero.consumo * tempoDeVoo).toFixed(2))
					this.form.aeronave.tempoTotal = Number(
						Number(tempoDeVoo) + Number(this.form.aeronave.tempoTotal)
					).toFixed(2)
					this.form.aeronave.combustivelTotal += Number(item.combustivel)
				}
				if (indexTrecho > 0 && aero.consumo > 0) {
					item.autonomia = this.decimalToTime(
						(aero.tanque -
							this.form.aeronave.roteiro[indexTrecho - 1].combustivel) /
							aero.consumo
					)
				}
			}

			item.decolagem = this._dateTimeToDateSQL(
				trecho.decolagem_partida + ' ' + trecho.decolagem_partida_hora,
				'DD/MM/YYYY HH:MM'
			)

			return item
		},

		exibeRoteiro(itemRot) {
			if (
				itemRot.estado_partida != itemRot.estado_destino ||
				itemRot.cidade_partida != itemRot.cidade_destino ||
				itemRot.designativo_partida != itemRot.designativo_destino
			) {
				return true
			}
			return false
		},

		calculoDistancia(latPartida, lngPartida, latDestino, lngDestino) {
			var distancia = null
			if ((latPartida, lngPartida, latDestino, lngDestino)) {
				const lat1 = this._convertDD(latPartida, 'lat')
				const lon1 = this._convertDD(lngPartida, 'lng')
				const lat2 = this._convertDD(latDestino, 'lat')
				const lon2 = this._convertDD(lngDestino, 'lng')

				distancia = this._calculaDistancia(lat2, lon2, lat1, lon1)
			}

			return distancia
		},

		toNumberCasa(val, casas) {
			return Number(Number(val).toFixed(casas))
		},

		preencherVoo(item) {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})
			this._axios(
				`mg-siga/Despacho_emergencial/get_malha_copia/${item.id_malha}`,
				'get',
				{
					callback: async (retorno) => {
						if (retorno._request && retorno._status) {
							this.form.classificacao = _.find(this.classificacoes, (o) => {
								return o.id == retorno.lista.aeronave.id_classificacao
							})

							this.form.subclassificacao = _.find(
								this.subclassificacoes,
								(o) => {
									return o.id == retorno.lista.aeronave.id_subclassificacao
								}
							)

							this.form.identificacao_voo = retorno.lista.aeronave.numero_voo
							this.form.orgao = {
								descricao: retorno.lista.orgao.descricao,
								excluido: retorno.lista.orgao.excluido,
								id: retorno.lista.orgao.id,
								id_orgao: retorno.lista.orgao.id_orgao,
								nivel: retorno.lista.orgao.nivel,
								sigla: retorno.lista.orgao.sigla,
								unidade: retorno.lista.orgao.unidade
							}
							this.form.aeronave.trecho = await this.carregarEditarTrecho(
								retorno.lista.aeronave.trecho,
								true,
								retorno.lista.aeronave.numero_voo
							)
						}
					}
				}
			)
			window.bus.$emit('load-out')
		}
	}
}
</script>

<style>
.table-hover-tr:hover td {
	background: #f0f0f0;
	cursor: pointer;
}

.bk-success {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}

.erro-tab {
	color: red !important;
	background-color: #ff9688;
}
</style>